import { TOGGLE_LIST_DETAILS } from './constants'
import type { ToggleListDetailsAction, ToggleListDetailsPayload } from './types'

export function toggleListDetails({ channelsType }: ToggleListDetailsPayload): ToggleListDetailsAction {
  return {
    type: TOGGLE_LIST_DETAILS,
    payload: {
      channelsType,
    },
  }
}
